import { render, staticRenderFns } from "./SiteAlert.vue?vue&type=template&id=5a78c369&"
import script from "./SiteAlert.vue?vue&type=script&lang=ts&"
export * from "./SiteAlert.vue?vue&type=script&lang=ts&"
import style0 from "./SiteAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports